import { Card, Col, Pagination, Row, Tag } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import customerApi from '../../api/customer.api'
import pushApi from '../../api/push.api'
import ContentHeader from '../../components/shared/ContentHeader'
import styles from '../../styles/customer.module.scss'

const KakaoHistoryPage = () => {
  const navigate = useNavigate()
  const [templateList, setTemplateList] = useState({
    content: [],
    pageable: { pageNumber: 0, pageSize: 10 },
    totalElements: 0,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [kakaoTemplateData, setKakaoTemplateData] = useState({
    content: [],
    pageable: { pageNumber: 0, pageSize: 10 },
    totalElements: 0,
  })

  const getTemplateList = async (page = 0) => {
    try {
      const res = await pushApi.getPushHistoryList({
        page: page,
        size: 10,
      })

      setTemplateList({
        content: res.data.content,
        pageable: res.data.pageable,
        totalElements: res.data.totalElements,
      })
    } catch (error) {
      console.log('getTemplateList error:', error.response?.data || error)
    }
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
    getTemplateList(page - 1) // API는 0-based, Pagination은 1-based
  }

  const getKakaoTemplateList = async (page = 0) => {
    try {
      const res = await customerApi.readKakaoTemplateList({
        page: page,
        size: 10,
      })
      if (res.status === 200) {
        setKakaoTemplateData({
          content: res.data.content,
          pageable: { pageNumber: page, pageSize: 10 },
          totalElements: res.data.totalElements,
        })
      } else {
        console.log('API 응답 상태가 200이 아닙니다:', res.status)
      }
    } catch (error) {
      if (error.response) {
        // 500 에러인 경우 사용자에게 알림
        if (error.response.status === 500 && page === 2) {
          alert(
            '3페이지에서 서버 오류가 발생했습니다. 서버 개발팀에 문의가 필요합니다.',
          )
        }
      }
    }
  }

  const getTemplateContent = (item) => {
    if (!item.interpolations) return '❤️'

    const interpolations = item.interpolations
    const variables = Object.entries(interpolations).map(([key, value]) => {
      // #{변수명} 형태에서 변수명만 추출
      const variableName = key.replace('#{', '').replace('}', '')
      return { name: variableName, value: value }
    })

    return (
      <div style={{ fontSize: '12px', color: '#666' }}>
        {variables.map((variable, index) => (
          <div key={index} style={{ marginBottom: '4px' }}>
            <span style={{ fontWeight: 'bold', color: '#1171a7' }}>
              {variable.name}:
            </span>{' '}
            <span style={{ color: '#333' }}>{variable.value}</span>
          </div>
        ))}
      </div>
    )
  }

  const handleCardClick = (item) => {
    navigate(`/customer/kakao-history/${item.id}`, { state: { item } })
  }

  useEffect(() => {
    getTemplateList()
    getKakaoTemplateList()
  }, [])

  return (
    <>
      <ContentHeader title="카카오 알림톡 내역" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }} // TODO: 사이즈 고려 중
      >
        <div
          className={`${styles['product-register-border-box']}`}
          style={{ padding: '20px 25px 40px 25px', height: 'fit-content' }}
        >
          {/* 카드 형태의 카카오 알림톡 발송 내역 */}
          <Row gutter={[16, 16]}>
            {/* 샘플 데이터 - 실제 데이터로 교체 필요 */}
            {templateList.content.map((item) => {
              return (
                <Col span={24} key={item.id}>
                  <Card
                    hoverable
                    style={{
                      borderRadius: '12px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      border: '1px solid #f0f0f0',
                      marginBottom: '16px',
                      cursor: 'pointer',
                    }}
                    onClick={() => handleCardClick(item)}
                  >
                    <Row gutter={[24, 0]} align="middle">
                      {/* 왼쪽: 콘솔 버튼 + 메시지 내용 */}
                      <Col flex="1">
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '16px',
                          }}
                        >
                          {/* 콘솔 버튼 */}
                          <Tag
                            color="default"
                            style={{
                              backgroundColor: '#f5f5f5',
                              border: '1px solid #d9d9d9',
                              borderRadius: '6px',
                              padding: '4px 12px',
                              marginTop: '2px',
                            }}
                          >
                            {item.id}
                          </Tag>

                          {/* 메시지 내용 */}
                          <div style={{ flex: 1 }}>
                            {/* 상품명 표시 */}
                            {item.productName && (
                              <div
                                style={{
                                  fontWeight: 'bold',
                                  fontSize: '16px',
                                  marginBottom: '8px',
                                  color: '#262626',
                                }}
                              >
                                {item.productName}
                              </div>
                            )}
                            <div
                              style={{
                                fontSize: '14px',
                                color: '#8c8c8c',
                                marginBottom: '12px',
                              }}
                            >
                              {item.crmType === 'ALIM_TALK'
                                ? `[카카오 알림톡] ${item.templateId}`
                                : '-'}
                            </div>
                            <div
                              style={{
                                fontSize: '13px',
                                color: '#595959',
                                lineHeight: '1.5',
                              }}
                            >
                              {getTemplateContent(item)}
                            </div>
                          </div>
                        </div>
                      </Col>

                      {/* 오른쪽 */}
                      <Col flex="300px">
                        <div style={{ textAlign: 'right' }}>
                          <div
                            style={{
                              marginBottom: '12px',
                              fontSize: '12px',
                              color: '#8c8c8c',
                            }}
                          >
                            {item.createdAt
                              ? dayjs(item.createdAt).format('YYYY.MM.DD')
                              : '-'}
                          </div>

                          {/* 통계 정보 */}
                          {/* <Row gutter={[16, 8]} justify="end">
                            <Col>
                              <Statistic
                                title="전체 유저"
                                value={item.totalUsers || '0'}
                                valueStyle={{
                                  fontSize: '14px',
                                  fontWeight: 'bold',
                                }}
                                titleStyle={{
                                  fontSize: '12px',
                                  color: '#8c8c8c',
                                }}
                              />
                            </Col>
                            <Col>
                              <Statistic
                                title="발송 유저"
                                value={item.sentUsers || '0'}
                                valueStyle={{
                                  fontSize: '14px',
                                  fontWeight: 'bold',
                                }}
                                titleStyle={{
                                  fontSize: '12px',
                                  color: '#8c8c8c',
                                }}
                              />
                            </Col>
                            <Col>
                              <Statistic
                                title="전환 유저"
                                value={item.conversionUsers || '0'}
                                valueStyle={{
                                  fontSize: '14px',
                                  fontWeight: 'bold',
                                }}
                                titleStyle={{
                                  fontSize: '12px',
                                  color: '#8c8c8c',
                                }}
                              />
                            </Col>
                            <Col>
                              <Statistic
                                title="ROAS"
                                value={item.roas || '0%'}
                                suffix="%"
                                valueStyle={{
                                  fontSize: '14px',
                                  fontWeight: 'bold',
                                }}
                                titleStyle={{
                                  fontSize: '12px',
                                  color: '#8c8c8c',
                                }}
                              />
                            </Col>
                          </Row> */}
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              )
            })}
          </Row>

          {/* 페이지네이션 */}
          <div
            style={{
              marginTop: '20px',
              textAlign: 'right',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Pagination
              current={currentPage}
              total={templateList.totalElements}
              pageSize={10}
              onChange={handlePageChange}
              showSizeChanger={false}
              showQuickJumper
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default KakaoHistoryPage
